<div>
    <h2>{{ applicationCall ? 'Edit a scheduled call' : 'Schedule a call'}}</h2>
    <form [formGroup]="scheduleCallFormGroup">
        <div class="row">

            <mat-form-field appearance="outline" *ngIf="application.Co_Appl_Required === 'Yes'">
                <mat-label>Applicant</mat-label>
                <mat-select formControlName="applicant">
                    <mat-option value="MAIN">Main applicant</mat-option>
                    <mat-option value="CO">Co applicant</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Owner</mat-label>
                <mat-select formControlName="ownedBy">
                    <mat-option style="background-color: white;">
                        <ngx-mat-select-search [formControl]="usersFilter"
                                               placeholderLabel="Search users"
                                               noEntriesFoundLabel="No matching users found" />
                    </mat-option>
                    <mat-option *ngFor="let user of filteredUsers | async" [value]="user.employeeID">
                        {{ user.full_name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <app-date-time-picker
                formControlName="dateTime"
                appearance="outline"
                [startTime]="'08:00'"
                [endTime]="'20:00'">
            </app-date-time-picker>

            <mat-form-field appearance="outline">
                <mat-label>Subject</mat-label>
                <input type="text" matInput formControlName="subject" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Reminder</mat-label>
                <mat-select formControlName="reminder">
                    <mat-option value="5">5 mins before</mat-option>
                    <mat-option value="10">10 mins before</mat-option>
                    <mat-option value="15">15 mins before</mat-option>
                    <mat-option value="30">30 mins before</mat-option>
                    <mat-option value="60">1 hrs before</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Purpose</mat-label>
                <mat-select formControlName="purpose">
                    <mat-option value="SCHEDULE_A_CALL">Schedule a call</mat-option>
                    <mat-option value="READY_FOR_LOAN_INTERVIEW">Ready for loan interview</mat-option>
                    <mat-option value="ADMINISTRATIVE">Administrative</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="applicationCall">
                <mat-label>Status</mat-label>
                <mat-select formControlName="status">
                    <mat-option value="SCHEDULED">Scheduled</mat-option>
                    <mat-option value="CANCELLED">Cancelled</mat-option>
                    <mat-option value="COMPLETED">Completed</mat-option>
                    <mat-option value="CALLED_CUSTOMER_NO_ANSWER">Called Customer – No Answer</mat-option>
                    <mat-option value="CALLED_CUSTOMER_NO_ANSWER_ATTEMPTED_TO_LEAVE_VOICE_MAIL">Called Customer – No Answer, attempted to leave voice mail</mat-option>
                    <mat-option value="CALLED_CUSTOMER_PARTIAL_DOCUMENTS_UPLOADED">Called Customer – Partial Documents Uploaded</mat-option>
                    <mat-option value="CALLED_CUSTOMER_ALL_DOCUMENTS_UPLOADED">Called Customer – All Documents Uploaded</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row">
            <div class="col" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                <div style="display: flex; gap: 0.7em;">
                    <button mat-raised-button color="primary" [disabled]="scheduleCallFormGroup.invalid"
                            (click)="onSubmit()">Save
                    </button>
                    <button mat-button color="primary" (click)="bottomSheetRef.dismiss()">Cancel</button>
                </div>
                <button mat-button color="warn" *ngIf="applicationCall" (click)="onDelete()">Delete</button>
            </div>
        </div>
    </form>
</div>
